<template>
  <div
    v-if="textRangeGroupCombosFiltered && textRangeGroupCombosFiltered.length > 0"
    class="similar-listing-filters-container"
  >
    <div
      v-for="group in textRangeGroupCombosFiltered"
      :key="group.similarGroupId"
      class="similar-listing-filters-group"
    >
      <GroupFilter
        v-if="!isBaseGroup(group)"
        :group="group"
        :entries="group.similars.chunks"
        :is-base-group="isBaseGroup(group)"
      >
      </GroupFilter>
    </div>
  </div>
</template>

<script>
import GroupFilter from './GroupFilter'

export default {
  name: 'TextRangeGroupListingFilters',
  components: {
    GroupFilter
  },
  props: {
    textRangeGroupCombos: {
      type: Array
    }
  },
  computed: {
    textRangeGroupCombosFiltered () {
      return this.textRangeGroupCombos.filter(
        (combo) => {
          return (combo.similarDisplayType === 'text-range-per-count' || combo.similarDisplayType === 'text-range-per-value') && this.shouldDisplayCombo(combo)
        }
      )
    }
  },
  methods: {
    isBaseGroup (group) {
      return !(group.similarDisplayType === 'text-range-per-count' || group.similarDisplayType === 'text-range-per-value')
    },
    shouldDisplayCombo (combo) {
      return combo.similarGroupDisplayPosition === 0 || combo.similarGroupDisplayPosition === 2
    }
  }
}
</script>
